(function(){
var top_=document.querySelector('.top'),burger=document.querySelector('.burger');
if(top_&&burger){
  burger.addEventListener('click',function(){var o=top_.classList.toggle('open');burger.setAttribute('aria-expanded',o)});
  top_.querySelectorAll('.links a').forEach(function(a){a.addEventListener('click',function(){top_.classList.remove('open')})});
}

function initTilt(){
  var card=document.querySelector('.card'),hero=document.querySelector('.hero');
  if(!card||!hero||hero.dataset.tilt)return;
  hero.dataset.tilt='1';
  if(matchMedia('(hover:hover)').matches&&!matchMedia('(prefers-reduced-motion:reduce)').matches){
    var cl=function(v){return Math.max(-.6,Math.min(.6,v))};
    hero.addEventListener('mousemove',function(e){
      var r=card.getBoundingClientRect(),x=cl((e.clientX-r.left)/r.width-.5),y=cl((e.clientY-r.top)/r.height-.5);
      card.style.setProperty('--ry',(x*9).toFixed(2)+'deg');card.style.setProperty('--rx',(-y*9).toFixed(2)+'deg');
    });
    hero.addEventListener('mouseleave',function(){card.style.setProperty('--rx','0deg');card.style.setProperty('--ry','0deg')});
  }
}

function splitQuote(){
  document.querySelectorAll('.q').forEach(function(b){
    if(b.dataset.split)return;b.dataset.split='1';
    var t=b.textContent.trim().split(/\s+/);
    b.innerHTML=t.map(function(w,i){return '<span class="w" style="--i:'+i+'">'+w.replace(/&/g,'&amp;').replace(/</g,'&lt;')+'</span>'}).join(' ');
  });
}

var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.2});
function observe(){
  document.querySelectorAll('.detail').forEach(function(n){
    if(window.Shopify&&Shopify.designMode){n.classList.add('in')}else if(!n.dataset.obs){n.dataset.obs='1';io.observe(n)}
  });
}
function initSlideshows(){
  document.querySelectorAll('[data-slideshow]').forEach(function(box){
    if(box.dataset.bound)return;
    var slides=[].slice.call(box.querySelectorAll('.slide'));
    if(slides.length<2)return;
    box.dataset.bound='1';
    var i=0,timer=null,vis=true,
        auto=box.dataset.autoplay!=='false'&&!matchMedia('(prefers-reduced-motion:reduce)').matches,
        ms=parseInt(box.dataset.interval,10)||5000;
    var dots=document.createElement('div');dots.className='dots';
    var btns=slides.map(function(s,n){
      var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Visa bild '+(n+1));
      b.addEventListener('click',function(){go(n);restart()});dots.appendChild(b);return b;
    });
    box.parentNode.appendChild(dots);btns[0].classList.add('on');
    function go(n){
      slides[i].classList.remove('is-active');btns[i].classList.remove('on');
      i=(n+slides.length)%slides.length;
      slides[i].classList.add('is-active');btns[i].classList.add('on');
    }
    function stop(){if(timer){clearInterval(timer);timer=null}}
    function start(){
      if(!auto||timer||document.hidden||!vis)return;
      timer=setInterval(function(){if(!document.body.contains(box)){stop();return}go(i+1)},ms);
    }
    function restart(){stop();start()}
    document.addEventListener('visibilitychange',function(){if(!document.body.contains(box))return;document.hidden?stop():start()});
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){vis=es[0].isIntersecting;vis?start():stop()}).observe(box);
    }else{start()}
  });
}

function initGalleries(){
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    if(g.dataset.bound)return;
    var slides=[].slice.call(g.querySelectorAll('.g-slide')),thumbs=[].slice.call(g.querySelectorAll('.g-thumb')),i=0;
    if(slides.length<2)return;
    g.dataset.bound='1';
    function show(n){
      n=(n+slides.length)%slides.length;
      slides[i].classList.remove('is-active');
      if(thumbs[i]){thumbs[i].classList.remove('on');thumbs[i].removeAttribute('aria-current')}
      i=n;slides[i].classList.add('is-active');
      if(thumbs[i]){thumbs[i].classList.add('on');thumbs[i].setAttribute('aria-current','true')}
    }
    g.querySelectorAll('[data-dir]').forEach(function(b){b.addEventListener('click',function(){show(i+parseInt(b.dataset.dir,10))})});
    thumbs.forEach(function(t,n){t.addEventListener('click',function(){show(n)})});
    g.addEventListener('keydown',function(e){
      if(e.key==='ArrowLeft')show(i-1);else if(e.key==='ArrowRight')show(i+1);
    });
    var main=g.querySelector('.g-main'),x0=null;
    main.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
    main.addEventListener('touchend',function(e){
      if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;x0=null;
      if(Math.abs(dx)>40)show(i+(dx<0?1:-1));
    },{passive:true});
    var sel=(g.closest('.pdp')||document).querySelector('select[name=id]');
    if(sel)sel.addEventListener('change',function(){
      var o=sel.options[sel.selectedIndex],m=o&&o.dataset.media;if(!m)return;
      slides.forEach(function(s,n){if(s.dataset.mediaId===m)show(n)});
    });
  });
}

function init(){initTilt();splitQuote();observe();initSlideshows();initGalleries()}
init();
document.addEventListener('shopify:section:load',init);

/* Förhindra dubbelklick på köpknappen */
document.addEventListener('submit',function(e){
  var f=e.target;
  if(e.defaultPrevented||!f.classList||!f.classList.contains('buyform'))return;
  if(f.dataset.sent){e.preventDefault();return}
  f.dataset.sent='1';
});
window.addEventListener('pageshow',function(){document.querySelectorAll('.buyform').forEach(function(f){delete f.dataset.sent})});

/* Cookiebanner */
var bn=document.querySelector('.cc');
if(bn){
  var KEY='stalkortet-cookie-consent',panel=bn.querySelector('.cc-set'),stat=bn.querySelector('[name=stat]'),mark=bn.querySelector('[name=mark]');
  var read=function(){try{return JSON.parse(localStorage.getItem(KEY))}catch(e){return null}};
  var toShopify=function(c){
  try{
    if(!window.Shopify||!Shopify.loadFeatures)return;
    Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(err){
      if(err||!Shopify.customerPrivacy)return;
      Shopify.customerPrivacy.setTrackingConsent({analytics:!!c.analytics,marketing:!!c.marketing,preferences:!!c.analytics,sale_of_data:!!c.marketing},function(){});
    });
  }catch(e){}
  } ;
  var emit=function(c){toShopify(c);document.dispatchEvent(new CustomEvent('cookie-consent',{detail:c}))};
  var hide=function(){bn.classList.remove('on');setTimeout(function(){bn.hidden=true},500)};
  var show=function(){var c=read();stat.checked=!!(c&&c.analytics);mark.checked=!!(c&&c.marketing);bn.hidden=false;requestAnimationFrame(function(){requestAnimationFrame(function(){bn.classList.add('on')})})};
  var delCk=function(test){
    var host=location.hostname,parts=host.split('.'),doms=[host,'.'+host];
    if(parts.length>2)doms.push('.'+parts.slice(-2).join('.'));
    document.cookie.split(';').forEach(function(ck){
      var n=ck.split('=')[0].trim();
      if(n&&test(n)){
        doms.concat(['']).forEach(function(d){document.cookie=n+'=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;'+(d?' domain='+d+';':'')});
      }
    });
  };
  var isMk=function(n){return n==='_ttp'||n==='_tt_enable_cookie'||n.indexOf('ttcsid')===0||n.indexOf('_tt_')===0||n==='_fbp'||n==='_fbc'||n==='fr'||n.indexOf('_gcl_')===0||n.indexOf('_gac_')===0||n==='FPAU'};
  var isAn=function(n){return n==='_ga'||n.indexOf('_ga_')===0||n==='_gid'||n.indexOf('_gat')===0||n==='FPID'||n==='FPLC'};
  var clean=function(c){if(!c.marketing)delCk(isMk);if(!c.analytics)delCk(isAn)};
  var save=function(a,m){
    var prev=read();var had=!!(prev&&(prev.marketing||prev.analytics))&&((prev.marketing&&!m)||(prev.analytics&&!a));
    var c={necessary:true,analytics:a,marketing:m,ts:Date.now()};
    try{localStorage.setItem(KEY,JSON.stringify(c))}catch(e){}
    emit(c);hide();clean(c);
    if(had)setTimeout(function(){clean(c);location.reload()},400);
  };
  var c0=read();
  if(c0)clean(c0);
  if(c0)emit(c0);else setTimeout(show,900);
  bn.querySelector('[data-cc=all]').addEventListener('click',function(){save(true,true)});
  bn.querySelector('[data-cc=min]').addEventListener('click',function(){save(false,false)});
  bn.querySelector('[data-cc=save]').addEventListener('click',function(){save(stat.checked,mark.checked)});
  bn.querySelector('[data-cc=cust]').addEventListener('click',function(e){panel.hidden=!panel.hidden;e.currentTarget.setAttribute('aria-expanded',String(!panel.hidden))});
  document.querySelectorAll('[data-cc=open]').forEach(function(b){b.addEventListener('click',function(){panel.hidden=false;bn.querySelector('[data-cc=cust]').setAttribute('aria-expanded','true');show()})});
}
})();
